export default "__VITE_ASSET__B5dV7Xrw__"